import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import RefreshForm from '../forms/refresh-form';
import { refreshValidationSchema } from '../schema/refresh.js';

export default function RefreshNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Refresh Node Details',
        altText: 'Refresh Node',
        defaultLabel: data?.command || 'Refresh Node',
        forceDefaultLabel: true,
      }}
    >
      <CommonNode FormComponent={RefreshForm} schemaResolver={refreshValidationSchema} />
    </NodeProvider>
  );
}
